import {
  getCountries as libGetCountries,
  isValidNumberForRegion as libIsValidNumberForRegion,
  type CountryCode
} from "libphonenumber-js";

// Properties are not configuable, so jest can't spy on them, so making a proxy here
export const getCountries = () => libGetCountries();
export const isValidNumberForRegion = (phone: string, region: CountryCode) => libIsValidNumberForRegion(phone, region);
